import React, { FC } from 'react';
import { AdfoxContextProvider, AdfoxContextProviderProps } from '../../context/AdfoxContext';
import { AdfoxBannerContainer } from '../../../AdfoxBannerContainer';
import { FILTERS_BLOCK_HEIGHT } from '../../../internal/contansts';

const POST_VIEW_ANALYTICS_DATA: AdfoxContextProviderProps['postViewAnalyticsData'] = {
  place: 'filters',
  place__DEPRECATED: 'maintage',
  name__DEPRECATED: 'maintage_brand_filters',
};

const P_PARAMS: AdfoxContextProviderProps['pParams'] = { p1: 'crutn', p2: 'fjjq' };

const SIZE: AdfoxContextProviderProps['size'] = { height: FILTERS_BLOCK_HEIGHT, width: '100%' };

export const MainpageBrandFiltersBanner: FC = () => {
  return (
    <AdfoxContextProvider postViewAnalyticsData={POST_VIEW_ANALYTICS_DATA} size={SIZE} pParams={P_PARAMS}>
      <AdfoxBannerContainer />
    </AdfoxContextProvider>
  );
};
